"use strict";
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var mobx_react_1 = require("mobx-react");

require("./fieldDropdown.scss");

var FieldDropdown =
/** @class */
function (_super) {
  __extends(FieldDropdown, _super);

  function FieldDropdown(props) {
    var _this = _super.call(this, props) || this;

    var currentText = _this.props.currentDataItem.getLabel();

    _this.state = __assign({
      userTextInput: currentText
    }, FieldDropdown.defaultState);

    var icons = _this.props.uiContext.getIcons();

    _this._dropDownOpenedId = icons.getIcon('common-chevron_up_16').id;
    _this._dropDownClosedId = icons.getIcon('common-chevron_down_16').id;
    _this._clearInputId = icons.getIcon('common-close_16').id;
    _this.dropdownWrapperRef = react_1.default.createRef();
    return _this;
  }

  FieldDropdown.prototype.componentDidUpdate = function () {
    this._resizeContents();
  };

  FieldDropdown.prototype.render = function () {
    return react_1.default.createElement("div", {
      className: 'vis-cf-dropdownWrapper',
      onBlur: this._onBlur.bind(this)
    }, this._renderTextInput(), react_1.default.createElement(ca_ui_toolkit_1.Collapse, {
      className: 'ba-common-dropdown dropdown vis-cf-fieldDropdown',
      style: {
        overflowY: 'scroll'
      },
      isOpened: this.state.openDropDown,
      autoUnmount: true,

      /* Has to use this prop to control if we want animation when dropdown content changes, check https://github.com/nkbt/react-collapse */
      hasNestedCollapse: true
    }, this._renderMetadataTree()));
  };

  FieldDropdown.prototype.onSlideoutMounted = function () {
    this._resizeContents();
  };

  FieldDropdown.prototype._resizeContents = function () {
    var showClearIcon = this.state.showClearIcon;

    if (!showClearIcon && this.dropdownWrapperRef.current) {
      var openFieldDropdownNode_1;
      var width_1 = this.dropdownWrapperRef.current.offsetWidth;
      var children = Array.prototype.slice.call(this.dropdownWrapperRef.current.childNodes);
      children.forEach(function (node) {
        var $node = $(node);

        if ($node.hasClass('vis-cf-fieldDropdown-opener')) {
          openFieldDropdownNode_1 = node;
        } else {
          // Decrease the width by node offsetWidth amount
          width_1 -= node.offsetWidth;
        }
      });

      if (openFieldDropdownNode_1) {
        // Ensure width cannot be negative, if negative set to 0
        // width becomes negative when the label is too long to fit within the allocated size so set to it zero
        width_1 = width_1 > 0 ? width_1 : 0;
        $(openFieldDropdownNode_1).css('width', Math.floor(width_1) + "px");
      }
    }
  };

  FieldDropdown.prototype._renderTextInput = function () {
    var _a = this.state,
        editing = _a.editing,
        openDropDown = _a.openDropDown,
        userTextInput = _a.userTextInput,
        showClearIcon = _a.showClearIcon;
    var iconButtonProps = {
      iconSize: 'small',
      variant: 'icon',
      intent: 'primary'
    };
    var clearButton = react_1.default.createElement(ca_ui_toolkit_1.Button, __assign({
      icon: this._clearInputId,
      onClick: this._onClickClearInputButton.bind(this)
    }, iconButtonProps));
    var blankSpaceDiv = react_1.default.createElement("div", {
      className: 'vis-cf-fieldDropdown-opener',
      onClick: this._onClickDropdownHandle.bind(this)
    });
    var collapseButton = react_1.default.createElement(ca_ui_toolkit_1.Button, __assign({
      icon: openDropDown ? this._dropDownOpenedId : this._dropDownClosedId,
      onClick: this._onClickDropdownHandle.bind(this)
    }, iconButtonProps));
    var trailingButtons = react_1.default.createElement(react_1.default.Fragment, null, showClearIcon && clearButton, !showClearIcon && blankSpaceDiv, collapseButton);
    var textInput = react_1.default.createElement(ca_ui_toolkit_1.TextInput, {
      className: 'vis-cf-colorby-textInput',
      ref: function ref(input) {
        input && input.focus();
      },
      value: userTextInput,
      noBottomBorder: true,
      onChange: this._onTextValueChange.bind(this),
      onFocus: this._onFocus.bind(this)
    });
    var truncatedText = react_1.default.createElement("div", {
      className: 'vis-cf-colorby-truncatedText'
    }, react_1.default.createElement(ca_ui_toolkit_1.TruncatedText, {
      value: this._getCurrentDataItemLabel(),
      onClick: this._onTruncatedTextClick.bind(this)
    }));
    return react_1.default.createElement("div", {
      ref: this.dropdownWrapperRef,
      className: 'vis-cf-colorby-propertyValue'
    }, editing ? textInput : truncatedText, trailingButtons);
  };

  FieldDropdown.prototype._getCurrentDataItemLabel = function () {
    var uiContext = this.props.uiContext;
    var dataSource = uiContext.getDataSource();
    var conditionalFormatModel = uiContext.getConditionalFormatModel();
    var currentDataItemID = conditionalFormatModel.currentColorBy;
    var currentDataItemLabel = dataSource.getMetadataColumn(currentDataItemID).getLabel();
    return currentDataItemLabel;
  };

  FieldDropdown.prototype._renderMetadataTree = function () {
    var metaDataTree;
    var uiContext = this.props.uiContext;
    var _a = this.state,
        fullList = _a.fullList,
        userTextInput = _a.userTextInput;
    var searchString = fullList ? '' : userTextInput;

    if (this.state.openDropDown) {
      metaDataTree = uiContext.getDataSourceUI().getPickTree(uiContext.getSourceId(), searchString, this._performSelection.bind(this), ['Calculation', 'fact']);
    }

    return metaDataTree;
  };

  FieldDropdown.prototype._onTruncatedTextClick = function () {
    this.setState({
      editing: true
    });
  };

  FieldDropdown.prototype._onTextValueChange = function (value) {
    this.setState({
      userTextInput: value
    });
  };

  FieldDropdown.prototype._performSelection = function (selectedValue) {
    var uiContext = this.props.uiContext;

    if (selectedValue && selectedValue.getType() === 'fact') {
      this.setState({
        editing: false,
        userTextInput: selectedValue.getLabel(),
        openDropDown: false,
        showClearIcon: false
      });
      uiContext.getConditionalFormatModel().setCurrentColorBy(selectedValue.getId());
    }
  };

  FieldDropdown.prototype._onBlur = function (event) {
    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }

    this.setState({
      editing: false,
      openDropDown: false,
      showClearIcon: false
    });
  };

  FieldDropdown.prototype._onClickDropdownHandle = function () {
    this.setState({
      editing: false,
      openDropDown: !this.state.openDropDown,
      fullList: true,
      showClearIcon: false,
      userTextInput: this._getCurrentDataItemLabel()
    });
  };

  FieldDropdown.prototype._onClickClearInputButton = function () {
    this.setState({
      editing: true,
      openDropDown: true,
      showClearIcon: false,
      userTextInput: ''
    });
  };

  FieldDropdown.prototype._onFocus = function () {
    this.setState({
      editing: true,
      fullList: false,
      openDropDown: true,
      showClearIcon: this.state.userTextInput.length > 0,
      userTextInput: this._getCurrentDataItemLabel()
    });
  };

  FieldDropdown.defaultState = {
    openDropDown: false,
    fullList: false,
    showClearIcon: false,
    editing: false
  };
  return FieldDropdown;
}(react_1.Component);

exports.default = mobx_react_1.observer(FieldDropdown);
